module.exports = __webpack_public_path__ + "static/img/solution_img_6.d68d49c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-n/solution_img_6.png
// module id = OXAp
// module chunks = 22